var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.0691 10.3199c-.19 0-.38-.07-.53-.22l-5.54-5.53996-5.53996 5.53996c-.29.29-.77.29-1.06 0-.29-.28996-.29-.76996 0-1.05996l6.06996-6.07c.29-.29.77-.29 1.06 0l6.07 6.07c.29.29.29.77 0 1.05996-.14.15-.34.22-.53.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 21.2499c-.41 0-.75-.34-.75-.75v-16.82998c0-.41.34-.75.75-.75s.75.34.75.75v16.82998c0 .41-.34.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f24308f7dc9ea989b8aa9dc1576a4899.svg";
export { ForwardRef as ReactComponent };